import { render, staticRenderFns } from "./EditListObjects.vue?vue&type=template&id=6e202e0a&scoped=true"
import script from "./EditListObjects.vue?vue&type=script&lang=js"
export * from "./EditListObjects.vue?vue&type=script&lang=js"
import style0 from "./EditListObjects.vue?vue&type=style&index=0&id=6e202e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e202e0a",
  null
  
)

export default component.exports